import { Customer_Config } from "../action/action";

const initialState = {
    cusConfig: {},
};

//Customer configuration reducer
const customerConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case Customer_Config:
            return { ...state, cusConfig: action.cusConfig };
        default:
            return state;
    }
}

export default customerConfigReducer;